module.exports = __webpack_public_path__ + "static/lit-signet-black-642983bac705cc6304052e1b3821f0c1.png";